import React from 'react';

const NotFound = () => {
  return (
    <>
      <h1>Not Found</h1>
      <p className="lead">The page does not exists.</p>
    </>
  );
};

export default NotFound;
